import { useNewRelic } from '@e3dc-react/shell/Libs/observability-tool'
import React from 'react'
import { Navigate } from 'react-router-dom'
import { UserLevel } from 'src/State/User/UserModel'

interface Props {
  loading?: boolean
  allowedRoles: UserLevel[]
  userLevel: UserLevel
  children: React.ReactNode
}

/**
 * Component that replaces the ProtectedRoute component, so it protects routes from being reached by wrong user level
 */
const RequireUserLevel: React.FC<Props> = ({ loading = false, allowedRoles, userLevel, children }) => {
  const { pageActions } = useNewRelic()

  if (loading || !userLevel) {
    return null
  }

  if (!(userLevel && allowedRoles.includes(userLevel))) {
    pageActions.logEvent({ logValue: `RequireUserLevel. userLevel: ${userLevel}, allowedRoles: ${allowedRoles}` })
    return <Navigate to="/not-found" />
  }
  return <>{children}</>
}

export default RequireUserLevel
